import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import { isEmpty } from 'utils/validations'
import * as parameterActions from 'action/totemSystemParameters'
import ContentHeader from 'component/utils/ContentHeader'
import Breadcrumb from 'component/Breadcrumb'
import Grid from 'component/utils/Grid'
import ParameterTable from 'component/systemParameters/Table'
import Pagination from 'component/pagination/Pagination'
import Notification from 'component/utils/Notification'
import Filters from 'component/systemParameters/Filters'
import Form from 'component/systemParameters/EditModal'

class TotemSystemParametersContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    parameters: PropTypes.array.isRequired,
    fetchParameters: PropTypes.func.isRequired,
    getParameter: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    filter: PropTypes.object,
    updateFilter: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    parameter: PropTypes.object,
    error: PropTypes.object,
    resetEditParameter: PropTypes.func,
  }

  state = {
    modal: false,
    disabled: true,
  }

  componentDidMount() {
    this.handleFetchParameters()
  }

  handleInputChange = (event) => {
    const { target } = event
    const value = target.type === 'checkbox' ? target.checked : target.value
    const { name } = target
    const filter = {
      ...this.props.filter,
      [name]: value,
    }

    this.props.updateFilter(filter)
  }

  handleFiltersSubmit = (event) => {
    event.preventDefault()
    this.handleFetchParameters()
  }

  handleFetchParameters = (page) => {
    const {
      fetchParameters,
      auth: { user },
    } = this.props

    fetchParameters(user.totemToken, this.props.filter, page)
  }

  handleSubmit = (values) => {
    const {
      auth: { user },
      update,
    } = this.props

    update(user.totemToken, values, this.onSubmitSuccess)
  }

  onSubmitSuccess = () => {
    this.closeModal()
    this.handleFetchParameters()
  }

  renderEmptyNotification = () => {
    const { translate } = this.props

    return (
      <Notification
        className='notification-warning margin-top'
        message={translate('parameter-list.not-found')}
      />
    )
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('mobile.register') },
      { title: translate('systemParameters.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  closeModal = () => {
    const { resetEditParameter } = this.props

    this.setState({ modal: false })

    resetEditParameter()
  }

  openModal = (index, disabled) => {
    const { getParameter } = this.props

    getParameter(index)

    this.setState({ modal: true, disabled })
  }

  renderModal = () => {
    const { modal, disabled } = this.state

    /* istanbul ignore else */
    if (!modal) {
      return
    }

    const {
      translate,
      error,
      auth: { user },
      parameter,
    } = this.props

    const initialValues = {
      ...parameter,
      tpValue: `${parameter.tpValue}`,
      inInactive: `${parameter.inInactive}`,
    }

    return (
      <Form
        translate={translate}
        error={error}
        user={user}
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
        closeModal={this.closeModal}
        disabled={disabled}
      />
    )
  }

  render() {
    const { translate, parameters, pages, current, count, filter, auth } =
      this.props

    return (
      <div>
        <ContentHeader>{translate('systemParameters.title')}</ContentHeader>

        {this.renderBreadcrumb()}

        <Grid fluid>
          <Filters
            translate={translate}
            filters={filter}
            handleSubmit={this.handleFiltersSubmit}
            handleInputChange={this.handleInputChange}
            auth={auth}
          />

          {isEmpty(parameters) ? (
            this.renderEmptyNotification()
          ) : (
            <ParameterTable
              parameters={parameters}
              translate={translate}
              openModal={this.openModal}
            />
          )}

          {pages > 1 && (
            <div className='align-center margin-top-double margin-bottom-double'>
              <Pagination
                getPage={this.handleFetchParameters}
                pages={pages}
                current={current}
                count={count}
              />
            </div>
          )}
        </Grid>

        {this.renderModal()}
      </div>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ systemParametersReducer, paginateReducer }) => ({
  parameters: systemParametersReducer.list.records,
  filter: systemParametersReducer.list.filter,
  parameter: systemParametersReducer.get.record,
  error: systemParametersReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...parameterActions }, dispatch)

const ParameterListTranslated = translate(null, { wait: true })(
  TotemSystemParametersContainer
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParameterListTranslated)

export { TotemSystemParametersContainer as TotemSystemParameters }
